import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import {dispatchEvent} from "fg-frontend/src/lib/dom";

const fragments = {
	INPUT_FROM: '[data-fragment="GridFilterDateInput.inputFrom"]',
	INPUT_TO: '[data-fragment="GridFilterDateInput.inputTo"]',
};

class GridFilterDateInput extends WebComponent {

	constructor(props) {
		super(props);
		const {
			dateInputItemLastActive = null,
		} = props;
		this.state = {
			dateInputItemLastActive,
		};
	}

	didMount() {
		const {
			itemActiveClass,
		} = this.props;

		this.itemActiveClass = itemActiveClass;

		this.inputFrom = this.element.querySelector(fragments.INPUT_FROM);
		this.inputTo = this.element.querySelector(fragments.INPUT_TO);
		this.on('click', fragments.INPUT_FROM, this.handleClickOnDateInput);
		this.on('click', fragments.INPUT_TO, this.handleClickOnDateInput);
	}

	handleClickOnDateInput = (e) => {
	  	e.preventDefault();
		const {
			dateInputItemLastActive,
		} = this.state;

		let isInside = false;

		const dateInputItem = e.closestTarget;
		let isClickInside = dateInputItem.querySelector('.flatpickr-calendar').contains(e.target);
		if (isClickInside) {
			isInside = true;
		}

		if (!isInside) {
			if(dateInputItem !== dateInputItemLastActive) {
				dateInputItem.classList.add(this.itemActiveClass);
				this.hideDateInputItemLastActive();
				this.setState({
					dateInputItemLastActive: dateInputItem,

				});
			} else {
				dateInputItem.classList.remove(this.itemActiveClass);
				this.setState({
					dateInputItemLastActive: null,
				});
			}
		}

	}

	hideDateInputItemLastActive = (e) => {
		const {
			dateInputItemLastActive,
		} = this.state;

		if(dateInputItemLastActive !== null) {
			dateInputItemLastActive.classList.remove(this.itemActiveClass);
			this.setState({
				dateInputItemLastActive: null,
			})
		}
	}

	willUnMount() {
		this.itemElements = null;
	}

	update(prevProps, prevState, inDocument) {
		const {
		} = this.state;
	}
}

GridFilterDateInput.defaultProps = {
	itemActiveClass: 'filter-date-input--active',
};

export default GridFilterDateInput;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/GridFilter/GridFilterDateInput.js